
import Icon from 'vux/src/components/icon/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
props: {
selectBar: ''
},
components: {
Tabbar,
TabbarItem,
Icon
},
methods:{

goToCart() {
window.location.href = '/html/cart'
}
}
}



// WEBPACK FOOTER //
// ./src/components/FootNav.vue